import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { providersApi } from 'apis/providers.apis';
import { ProviderInputPayload, UpdateProvider } from 'interfaces/providers.interfaces';
import { QueryParams } from 'interfaces/query.interfaces';
import { showServerError } from 'utils/modules.utils';
import { intl } from 'utils/translation.utils';

export const PROVIDERS_SLICE_NAME = 'providers';

export const asyncGetProviders = createAsyncThunk(
  `${PROVIDERS_SLICE_NAME}/getProviders`,
  async (query: QueryParams, { rejectWithValue }) => {
    try {
      const response = await providersApi.getProviders(query);
      return response.data;
    } catch (e) {
      showServerError(e);
      return rejectWithValue(e);
    }
  },
);

export const asyncGetProvider = createAsyncThunk(
  `${PROVIDERS_SLICE_NAME}/getProvider`,
  async (payload: string, { rejectWithValue }) => {
    try {
      const response = await providersApi.getProviderById(payload);
      return response.data.data;
    } catch (e) {
      showServerError(e);
      return rejectWithValue(e);
    }
  },
);

export const asyncUpdateProvider = createAsyncThunk(
  `${PROVIDERS_SLICE_NAME}/updateProvider`,
  async (payload: UpdateProvider, { rejectWithValue }) => {
    try {
      await providersApi.updateProvider(payload);
      toast.success(intl.formatMessage({ id: 'provider_updated' }));
      return null;
    } catch (e) {
      showServerError(e);
      return rejectWithValue(e);
    }
  },
);

export const asyncCreateProvider = createAsyncThunk(
  `${PROVIDERS_SLICE_NAME}/createProvider`,
  async (payload: ProviderInputPayload, { rejectWithValue }) => {
    try {
      await providersApi.createProvider(payload);
      toast.success(intl.formatMessage({ id: 'provider_created' }));
      return null;
    } catch (e) {
      showServerError(e);
      return rejectWithValue(e);
    }
  },
);

export const asyncDeleteProvider = createAsyncThunk(
  `${PROVIDERS_SLICE_NAME}/deleteProvider`,
  async (id: string, { rejectWithValue }) => {
    try {
      await providersApi.deleteProvider(id);
      toast.success(intl.formatMessage({ id: 'provider_deleted' }));
      return null;
    } catch (e) {
      showServerError(e);
      return rejectWithValue(e);
    }
  },
);

export const unsetProvider = createAction('UNSET_PROVIDER');
